import {debounce} from 'lodash'
import equalizeRows from './equalheightgridrows.js'

export default function (elementsSelector) {
  if ($(elementsSelector).length) {
    equalizeRows(elementsSelector)
    // Run the above again after images have loaded in case this has affected the measurements
    $(window).on('load', function () {
      equalizeRows(elementsSelector)
    })

    $(window).on('resize', debounce(function () {
      equalizeRows(elementsSelector)
    }, 150))
  }
}
